import { IconProps } from './index';

const PhoneDecline: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}

            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.3435 15.9336V19.4695C22.3436 19.7227 22.2477 19.9665 22.0751 20.1517C21.9025 20.337 21.6661 20.4498 21.4135 20.4676C20.9765 20.4976 20.6195 20.5136 20.3435 20.5136C16.5933 20.5136 13.1446 19.2235 10.4169 17.063L12.5569 14.923C13.378 15.538 14.275 16.0586 15.2325 16.4695L16.7725 14.3156C16.8355 14.2275 16.9273 14.1644 17.032 14.1372C17.1367 14.11 17.2477 14.1204 17.3455 14.1665C18.6105 14.7674 19.9591 15.1737 21.3455 15.3715C21.4845 15.3916 21.6675 15.4136 21.8955 15.4355C22.0188 15.4482 22.1329 15.5061 22.2159 15.5981C22.2988 15.6901 22.3447 15.8097 22.3445 15.9336H22.3435ZM7.55574 14.1317L1.65625 20.0312L3.11151 21.4865L20.2105 4.38751L18.7552 2.93225L9.70429 11.9832C9.189 11.2502 8.74703 10.4609 8.38852 9.62555L10.5465 8.08355C10.7265 7.95555 10.7885 7.71655 10.6935 7.51655C10.0915 6.25138 9.68426 4.90247 9.48552 3.51555C9.46552 3.37655 9.44452 3.19355 9.42152 2.96355C9.40912 2.84013 9.35128 2.72573 9.25925 2.64257C9.16722 2.55941 9.04756 2.51343 8.92352 2.51355H5.38752C5.13434 2.51344 4.89055 2.60936 4.70533 2.78196C4.5201 2.95456 4.40724 3.19099 4.38952 3.44355C4.35852 3.88055 4.34352 4.23755 4.34352 4.51355C4.34352 8.12374 5.53901 11.4546 7.55574 14.1317Z"
                fill="#ED434B"
            />
        </svg>
    );
};

export default PhoneDecline;
